// =====================================================
// File: src/api/LandlordDashboard.js
// Uses the landlordApi instance above; 401/403 auto-redirect to user sign-in
// =====================================================
import landlordApi from "./LandlordUser";

function authHeaders() {
  const token =
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("access_token");
  const type =
    localStorage.getItem("token_type") ||
    sessionStorage.getItem("token_type") ||
    "Bearer";
  return token ? { headers: { Authorization: `${type} ${token}` } } : {};
}

/* ----- Existing MTD/YTD dashboard endpoints ----- */
export const getDashboardAggregated = (body) =>
  landlordApi.post("/api/v1/landlord/dashboard/aggregated", body);

export const getDashboardSummary = (body) =>
  landlordApi.post("/api/v1/landlord/dashboard/summary", body);

export const getDashboardDetailed = (body) =>
  landlordApi.post("/api/v1/landlord/dashboard/detailed", body);

/* ----- YoY endpoints ----- */
export const getYoyGraphs = (body) =>
  landlordApi.post("/api/v1/landlord/dashboard/yoy/graphs", body);

export const getYoyFacilityBreakdown = (body) =>
  landlordApi.post("/api/v1/landlord/dashboard/yoy/facility-breakdown", body);

export const getYoyTiles = (body) =>
  landlordApi.post("/api/v1/landlord/dashboard/yoy/tiles", body);

/* ----- Reservations ----- */
export const getReservations = (body) =>
  landlordApi.post("/api/v1/landlord/dashboard/reservations", body);

export const exportReservations = (body) =>
  landlordApi.post("/api/v1/landlord/reservations_data", body);

export const exportCleanup = (secure_token) =>
  landlordApi.post(
    "/api/v1/landlord/cleanup",
    { secure_token }, // <-- backend expects the token in body
    authHeaders()
  );

/* ----- Accounting ----- */
export const getAccountingSummary = (body) =>
  landlordApi.post("/api/v1/landlord/dashboard/accounting/summary", body);

export const getAccountingFacilitiesBreakdown = (body) =>
  landlordApi.post(
    "/api/v1/landlord/dashboard/accounting/facilities-breakdown",
    body
  );

export const landlordForgotPassword = (email) =>
  landlordApi.post("/api/v1/auth/landlord/forgot-password", { email });

export const landlordResetPassword = ({ email, otp, new_password }) =>
  landlordApi.post("/api/v1/auth/landlord/reset-password", {
    email,
    otp,
    new_password,
  });

/* ----- 🔐 AUTH / PASSWORD RESET APIs ----- */
export const sendOtpForPasswordReset = (email) =>
  landlordApi.post("/api/v1/otp/send-otp", {
    email,
    purpose: "password_reset",
  });

export const verifyOtpForPasswordReset = (email, otp) =>
  landlordApi.post("/api/v1/auth/landlord/verify-otp", {
    email,
    otp,
    purpose: "password_reset",
  });
